import classnames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Loading, LoadingSize } from 'app/components/core/Loading';
import { StateTag } from './StateTag.jsx';
import * as styles from './WarehouseCard.css';

const cx = classnames.bind(styles);

function CardItem({ name, children, className, hideLabel: hide }) {
    const { t } = useTranslation('common');

    return (
        <div className={cx('attr')}>
            <dt className={cx({ hide })}>{name}</dt>
            <dd className={className}>{children ?? t('naDashes')}</dd>
        </div>
    );
}

export function WarehouseCard({
    name,
    state,
    running,
    queued,
    size,
    disabled,
    isSelected,
    isProcessing,
    onClick
}) {
    const { t } = useTranslation('components', { keyPrefix: 'WarehouseCard' });

    return (
        <dl
            role="option"
            className={cx('card')}
            onClick={onClick}
            tabIndex={0}
            aria-selected={isSelected}
            aria-disabled={disabled}>
            <CardItem name={t('name')} className={cx('name')} hideLabel>
                <span className={cx('elide')}>{name}</span>
                {isProcessing && <Loading size={LoadingSize.SMALL} />}
            </CardItem>
            <CardItem name={t('state')} hideLabel>
                <StateTag value={state} />
            </CardItem>
            <CardItem name={t('running')}>{running}</CardItem>
            <CardItem name={t('queued')}>{queued}</CardItem>
            <CardItem name={t('size')}>{size}</CardItem>
        </dl>
    );
}
